var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmail({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.1665 2.91699H5.83317C3.33317 2.91699 1.6665 4.16699 1.6665 7.08366V12.917C1.6665 15.8337 3.33317 17.0837 5.83317 17.0837H14.1665C16.6665 17.0837 18.3332 15.8337 18.3332 12.917V7.08366C18.3332 4.16699 16.6665 2.91699 14.1665 2.91699ZM14.5582 7.99199L11.9498 10.0753C11.3998 10.517 10.6998 10.7337 9.99984 10.7337C9.29984 10.7337 8.5915 10.517 8.04984 10.0753L5.4415 7.99199C5.17484 7.77533 5.13317 7.37533 5.3415 7.10866C5.55817 6.84199 5.94984 6.79199 6.2165 7.00866L8.82484 9.09199C9.45817 9.60033 10.5332 9.60033 11.1665 9.09199L13.7748 7.00866C14.0415 6.79199 14.4415 6.83366 14.6498 7.10866C14.8665 7.37533 14.8248 7.77533 14.5582 7.99199Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.d29b37b231dc8c916318f0ed09bf75bd.svg";
export { ForwardRef as ReactComponent };